<template>
  <BittsCallout
    type="upsell"
    size="medium"
    title="Help your partner get started faster"
    subtitle="CC our Partner Activation team to provide personalized support"
    class="activation-team-cc-callout"
    data-testid="activation-team-cc-callout"
  >
    <template #left-item>
      <FontAwesomeIcon
        :icon="['fak', 'team']"
        :style="{ height: '16px', width: '16px' }"
        class="text-secondary-accent self-start mt-2 mr-10 shrink-0"
      />
    </template>
    <template #right-item>
      <div class="ml-auto flex items-center">
        <BittsSwitch
          v-model="activationTeamCc"
          data-testid="activation-team-cc-switch"
        />
      </div>
    </template>
  </BittsCallout>
</template>

<script setup lang="ts">
import { BittsCallout, BittsSwitch } from '@crossbeam/bitts';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const activationTeamCc = defineModel<boolean>();
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.activation-team-cc-callout {
  background-image: linear-gradient(
    92deg,
    theme(colors.secondary-background-weak) 0%,
    color-mix(in srgb, theme(colors.secondary-background-weak) 20%, white) 100%
  );
}
</style>
